import { Injectable } from '@angular/core';
import { EventType } from 'src/app/models/evenType.enum';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  emitEventShowModal=()=>this.emitEvent('showModal');
  emitEventCloseModal=()=>this.emitEvent('closeModal');

  emitEventChangeCurrency=()=>this.emitEvent(EventType.ChangeCurrencyEvent);

  private emitEvent(eventName: string):void {
    const event = new CustomEvent(eventName);
    document.dispatchEvent(event);

  }
}
